import { gettext } from "@/plugins/gettext"
import { useAppStore } from "@/stores/appStore"
import { useAuthStore } from "@/stores/authStore"
import { router } from "@/plugins/1.router"
import { ofetch } from "ofetch"
import { langTypes } from "@/utils/constant"

// import CommonService from "@/services/CommonService"
export const COOKIE_MAX_AGE_1_YEAR = 365 * 24 * 60 * 60
export const CURRENT_YEAR = import.meta.env.VITE_CURRENT_YEAR || 2026
export const status = {
  HTTP_BAD_REQUEST: 400,
  HTTP_UNAUTHORIZED: 401,
  HTTP_FORBIDDEN: 403,
  HTTP_NOT_FOUND: 404,
  HTTP_INTERNAL_SERVER_ERROR: 500,
  HTTP_CONFLICT: 409,
  HTTP_UNPROCESSABLE_CONTENT: 422,
  HTTP_OK: 200,
  HTTP_CREATED: 201,
}
export const baseApiUrl = import.meta.env.VITE_API_BASE_URL || "/api"
export const $api = ofetch.create({
  baseURL: baseApiUrl,
  async onRequest({ options }) {
    const store = useAppStore()
    
    options.baseURL = store.selectedApiBaseUrl || baseApiUrl
    let uuid = false
    if (options.loading) {
      uuid = await store.startLoading()
      options.onResponse = ({ response }) => {
        store.endLoading(uuid)
        if (
          response.status !== status.HTTP_OK &&
          response.status !== status.HTTP_CREATED
        )
          return
        if (options.method === "POST") {
          if (!options.hasOwnProperty("noPushMessage")) {
            if (!options.hiddenMessage)
              store.pushErrorMessage({ success: true })
          }
        }
        if (options.method === "DELETE") {
          const { $gettext } = gettext
          if (!options.hiddenMessage)
            store.pushErrorMessage({
              success: true,
              detail: $gettext("Record deleted successfully"),
            })
        }
      }
    }
    const accessToken = useCookie("accessToken").value
    const userInfo = useCookie("user").value
    const locale = langTypes.find((x) => x.id === store.lang)
    options.headers = {
      ...options.headers,
      "X-Language": locale?.name || "fr",
    }
    if (accessToken) {
      options.headers = {
        ...options.headers,
        "X-W-Auth": `/Token Email="${
          userInfo?.email || ""
        }", Token="${accessToken}"/`,
      }
    }

    if (options.inline) {
      options.ignoreResponseError = true
    }
  },
  async onResponseError({ request, response, options }) {
    const { $gettext } = gettext
    // Log error
    //console.log("[fetch response error]",request,response.status,options);
    //console.log({'error': response._data})
    const appStore = useAppStore()
    if (
      (response.status === status.HTTP_UNAUTHORIZED ||
        (response.status === status.HTTP_FORBIDDEN &&
          response._data.error &&
          response._data.error ===
            "Auth token does not match with any user")) &&
      request !== `${options.baseURL}/auth`
    ) {
      const authStore = useAuthStore()
      // todo: should not push duplicate error here
      if (!options.hiddenMessage) appStore.pushErrorMessage(response._data)

      // authStore.logout()
      router.go(-1)
    }
    if (response.status === status.HTTP_FORBIDDEN) {
      if (!options.hiddenMessage)
        appStore.pushErrorMessage({
          status: response.status,
          detail: $gettext(
            "Not enough access rights to perform this operation"
          ),
        })
      return Promise.reject(response._data)
    }
    if (response.status === status.HTTP_NOT_FOUND) {
      if (!options.hiddenMessage)
        appStore.pushErrorMessage({
          status: response.status,
          detail: $gettext("Resource not found"),
        })
      return Promise.reject(response._data)
    }
    if (
      response.status === status.HTTP_BAD_REQUEST ||
      response.status === status.HTTP_FORBIDDEN ||
      response.status === status.HTTP_UNPROCESSABLE_CONTENT ||
      response.status === status.HTTP_CONFLICT ||
      response.status === status.HTTP_INTERNAL_SERVER_ERROR
    ) {
      // not show if its cache clear error
      if (
        response.status === status.HTTP_INTERNAL_SERVER_ERROR &&
        /Warning: rename.+Access is denied/.test(response._data.error)
      ) {
        console.log("CACHE CLEAR ERROR PANIC")
      } else {
        if (response.status === status.HTTP_BAD_REQUEST) {
          if (
            !options.hasOwnProperty("noPushMessage") &&
            response._data?.code !== "NULL_CONTACT_EDITION"
          ) {
            if (!options.hiddenMessage)
              appStore.pushErrorMessage(response._data || response._data?.error)
          }
        } else {
          if (!options.hiddenMessage) appStore.pushErrorMessage(response._data)
        }
      }
    }
    console.log("error fall silence", response)
    return Promise.reject(response._data)
  },
})
export const $gettext = gettext.$gettext
